import { createActions } from 'redux-actions';

export type InsuranceClaimQuickUpdatePayload = {
  claimableType: string;
  claimableId: number;
  status: string;
  totalClaimedAmount: number;
};

export type InsuranceClaimQuickUpdateSuccessPayload = {
  claimableType: string;
  claimableId: number;
};

export type InsuranceClaimQuickUpdateErrorPayload = {
  claimableType: string;
  claimableId: number;
};

export const {
  insuranceClaimQuickUpdate,
  insuranceClaimQuickUpdateSuccess,
  insuranceClaimQuickUpdateError
} = createActions(
  'INSURANCE_CLAIM_QUICK_UPDATE',
  'INSURANCE_CLAIM_QUICK_UPDATE_SUCCESS',
  'INSURANCE_CLAIM_QUICK_UPDATE_ERROR',
  {
    prefix: 'USER_DASHBOARD_INSURANCE_CLAIM_EDIT_MODAL',
  },
);
